/* @flow */
import * as React from 'react';

import Icon from 'components/Icon.jsx';
import Image from 'components/Image.jsx';
import MediaObject from 'components/MediaObject.jsx';
import Text from 'components/Text.jsx';
import TooltipTrigger from 'components/TooltipTrigger.jsx';
import Tooltip from 'components/Tooltip.jsx';

import './BankCard.scss';

type Props = {
  brand?: 'american-express' | 'discover' | 'mastercard' | 'visa' | 'other',
  expiryMonth: number,
  expiryYear: number,
  lastFour: string,
  zip: string,
};

export default function BankCard({ brand, expiryMonth, expiryYear, lastFour, zip }: Props) {
  const LOGOS = {
    'american-express': require('./images/american-express.svg'),
    discover: require('./images/discover.svg'),
    mastercard: require('./images/mastercard.svg'),
    visa: require('./images/visa.svg'),
    other: require('./images/other.svg'),
  };

  return (
    <div className="BankCard">
      <MediaObject center figure="right">
        <MediaObject center gutter="medium">
          <Image
            // $FlowIssue
            src={LOGOS[brand]}
            aria-hidden="true"
            className="BankCard-logo"
          />
          <Text size="medium" className="BankCard-numbers">
            <span>•••• •••• •••• {lastFour}</span>
            <span>
              {expiryMonth}/{expiryYear.toString().slice(-2)}
            </span>
            <span>{zip}</span>
          </Text>
        </MediaObject>
        <TooltipTrigger
          placement="top"
          tooltip={<Tooltip>All data is encrypted and protected with bank-level security</Tooltip>}>
          <Icon name="lock-stroked" aria-hidden="true" />
        </TooltipTrigger>
      </MediaObject>
    </div>
  );
}

BankCard.defaultProps = {
  brand: 'other',
};
